import { useRef, useState } from "react";
import GenericInput from "../../../../../common/GenericInput";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import AddIcon from "@mui/icons-material/Add";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import GenericModal from "../../../../../common/GenericModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import {
  addCandidate,
  updateEmailBody,
} from "../../../../../store/steps/stepFiveSlice";

const emailRegex = STATIC_STRINGS.EMAIL_REGEX;

const EmailInputCard = () => {
  const dispatch = useDispatch();
  const { emailBody } = useSelector((state: RootState) => state.stepFive);
  const [candidateName, setCandidateName] = useState<string>("");
  const [candidateEmail, setCandidateEmail] = useState<string>("");
  const [isEmailPreviewOpen, setEmailPreviewOpen] = useState("");
  const [localEmailBody, setLocalEmailBody] = useState(emailBody);
  const emailTextareaRef = useRef<HTMLTextAreaElement>(null);
  const isEmailValid = emailRegex.test(candidateEmail);

  return (
    <div className="w-1/2 ml-2 card h-full p-4 flex flex-col justify-between items-start">
      <div className="font-semibold">{STATIC_STRINGS.ADD_EMAIL_MANUALLY}</div>
      <div className="flex justify-between items-center w-full my-1">
        <div className="w-1/2">
          <div className="font-medium text-gray-700">
            {STATIC_STRINGS.CANDIDATE_NAME}
          </div>
          <GenericInput
            className="w-full"
            type="text"
            value={candidateName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setCandidateName(e.target.value);
            }}
            placeholder={STATIC_STRINGS.NAME_PLACEHOLDER}
          />
        </div>
        <div className="ml-1 w-1/2">
          <div className="font-medium text-gray-700">
            {STATIC_STRINGS.EMAIL}
          </div>
          <GenericInput
            className="w-full"
            type="email"
            value={candidateEmail}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setCandidateEmail(e.target.value);
            }}
            placeholder={STATIC_STRINGS.EMAIL_PLACEHOLDER}
          />
        </div>
      </div>
      <div className="flex flex-col xl:flex-row justify-between items-center w-full">
        <button
          className={`btn ${
            isEmailValid ? `btn-primary` : `btn-outline btn-outline-disabled`
          } py-1 px-2 flex items-center m-1 xl:m-0`}
          disabled={!isEmailValid}
          onClick={() => {
            dispatch(
              addCandidate({ name: candidateName, email: candidateEmail })
            );
            setCandidateName("");
            setCandidateEmail("");
          }}
        >
          <AddIcon className="mr-1" /> {STATIC_STRINGS.ADD_EMAIL}
        </button>
        <button
          className="btn btn-outline py-1 px-2 flex items-center m-1 xl:m-0"
          onClick={() => setEmailPreviewOpen("open")}
        >
          <MailOutlineIcon className="mr-1" />
          {STATIC_STRINGS.PREVIEW_EMAIL}
        </button>
      </div>
      <GenericModal
        onClose={() => setEmailPreviewOpen("")}
        onConfirm={() => {
          dispatch(updateEmailBody(localEmailBody));
          setEmailPreviewOpen("");
        }}
        open={isEmailPreviewOpen}
        title={STATIC_STRINGS.PREVIEW_EMAIL}
        body={
          <textarea
            className="w-full h-[40vh] p-1 border border-primary-light rounded-md focus:outline-none focus:ring-1 focus:ring-neutral-dark"
            ref={emailTextareaRef}
            value={localEmailBody}
            onChange={(e) => setLocalEmailBody(e.target.value)}
          />
        }
      />
    </div>
  );
};

export default EmailInputCard;
